var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.008%",
    y1: "29.136%",
    x2: "76.231%",
    y2: "54.099%",
    id: "tqoc5mqota"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.98%",
    y1: "46.299%",
    x2: "100.625%",
    y2: "71.067%",
    id: "k27e2f6c9b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.943%",
    y1: "36.377%",
    x2: "86.442%",
    y2: "64.577%",
    id: "yhm3177jic"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.023%",
    y1: "36.009%",
    x2: "85.478%",
    y2: "64.191%",
    id: "dxwp2mh3sd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32c6.56 0 12.19-3.951 14.66-9.6H1.34C3.81 28.049 9.44 32 16 32z",
    fill: "url(#tqoc5mqota)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.44 0 3.81 3.951 1.34 9.6h29.32C28.19 3.951 22.56 0 16 0z",
    fill: "url(#k27e2f6c9b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.66 9.6H1.34A15.929 15.929 0 0 0 0 16c0 2.277.483 4.44 1.34 6.4h29.32a15.942 15.942 0 0 0 0-12.8z",
    fill: "url(#yhm3177jic)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.66 9.6H1.34A15.929 15.929 0 0 0 0 16c0 2.277.483 4.44 1.34 6.4h29.32a15.942 15.942 0 0 0 0-12.8z",
    fill: "url(#dxwp2mh3sd)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.a1afd91878de5f3f6b5ba81ba6f3c1d6.svg";
export { ForwardRef as ReactComponent };